import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Search = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'search' */
  './Search'
))

export function AsyncSearch(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Search..." />}>
      <Search {...props} />
    </Suspense>
  )
}

export default AsyncSearch
